<template>
  <div
    class="option"
    :class="{ dragged: drag }"
    @click="onClickOption"
    v-html="text"
  />
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
    drag: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickOption(e) {
      e.stopPropagation();
      this.$emit('clickOption', e);
    },
  },
};
</script>
<style scoped lang="scss">
.option {
  color: #db841e;
  padding: 15px 20px;
  margin: 0 0 20px 0;
  background: #171818;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.5s;
  line-height: 1.5;
  user-select: none;

  &.dragged {
    background: #171818 !important;
  }
  &:hover {
    color: #ff8a01;
    background: #292d2d;
    // padding-left: 20px;
  }

  p {
    margin: 0;
  }
}
</style>

<style lang="scss">
.option-container .option p {
  margin: 0;
}
</style>
